// extracted by extract-css-chunks-webpack-plugin
module.exports = {"list_menu":"list_menu-2I7u_5I9","morehNew":"morehNew-2CsrvBPr","more":"more-_54nOOLq"};